import { ShieldAlert } from "lucide-react";
import { Reveal } from "./Reveal";

export const Warning = () => (
  <section data-testid="warning-section" className="mx-auto max-w-[1400px] px-5 md:px-10">
    <Reveal>
      <div className="flex flex-col gap-4 rounded-2xl border border-amber-400/30 bg-amber-400/[0.06] p-6 md:flex-row md:items-center md:gap-6 md:p-8">
        <ShieldAlert className="h-10 w-10 shrink-0 text-volt" />
        <p className="text-base leading-relaxed text-zinc-200 md:text-lg">
          <span className="font-semibold text-paper">Tidak menerima pulsa ilegal</span> seperti penipuan, cloning SIM, judi online, atau hasil bug. Pastikan pulsa kamu dari sumber yang jelas.
        </p>
      </div>
    </Reveal>
  </section>
);
